
import styled from 'styled-components';
import { colors } from '../styles/tokens';

export const TabsContainer = styled.div`
  display: flex;
  justify-content: stretch;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 20px;
`;

export const Tab = styled.div`
  align-items: center;
  color: ${(props: any) => props.active ? '#fff' : 'rgba(255,255,255,0.5)'};
  display: flex;
  justify-content: center;
  text-decoration: none;
  background: transparent;
  white-space: nowrap;
  cursor: pointer;
  border-bottom: 2px solid ${(props: any) => props.active ? colors.primary : 'transparent'};
  padding: 12px 16px;
  margin-bottom: -1px;
  font-size: 13px;
  font-weight: 600;
  flex: 1;
  transition: color 0.15s, border-color 0.15s;
  gap: 8px;

  &:hover {
    color: ${(props: any) => props.active ? '#fff' : 'rgba(255,255,255,0.85)'};
  }

  > p {
    font-size: 13px;
    margin: 0;
  }
`;

export const TabBadge = styled.span`
  background: ${(props: any) => props.active ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)'};
  color: ${(props: any) => props.active ? '#fff' : 'rgba(255,255,255,0.5)'};
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
`;
